import { createContext, useContext } from 'react';
import useDiscoveryOverview from '../hooks/useDiscoveryOverview';

const DiscoveryOverviewContext = createContext(null);

export const DiscoveryOverviewProvider = ({ children }) => {
  const discoveryOverview = useDiscoveryOverview();

  return (
    <DiscoveryOverviewContext.Provider value={discoveryOverview}>
      {children}
    </DiscoveryOverviewContext.Provider>
  );
};

export const useDiscoveryOverviewContext = () => {
  const context = useContext(DiscoveryOverviewContext);

  if (!context) {
    throw new Error('useDiscoveryOverviewContext must be used within DiscoveryOverviewProvider');
  }

  return context;
};
